<template>
  <header class="site-header" id="masthead">
    <div class="container">
      <div class="grid">
        <div class="col-1-1">
          <div class="site-header-top">
            <div class="row">
              <div class="site-logo">
                <a :href="currentUrl" rel="home" itemprop="url">
                  <div class="logo--market" itemprop="logo">724 Market</div>
                </a>
              </div>
              <div class="site-logo-partner">
                <picture>
                  <source
                    :srcset="currentUrl + '/img/sale_page_single/' + item.section_value.header_photo_one"
                    media="(min-width: 375px)"
                  />
                  <!-- <source
                          srcset="uploads/site-logo-partner-380x108.png"
                          media="(min-width: 320px)"
                  >-->
                  <img
                    :src="currentUrl + '/img/sale_page_single/' + item.section_value.header_photo_one"
                  />
                </picture>
              </div>
              <!-- <div class="site-logo-partner">
                      <div class="figure">
                        <img :src="currentUrl + '/img/sale_page_single/' + item.section_value.header_photo_one" />
                      </div>
              </div>-->
              <div class="site-meta">
                <button class="btn btn--square showAccount" @click="shareButton()">
                  Share
                  <i class="fas fa-share-alt"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-1-1">
          <div class="site-header-below header-bg-color header-bg">
            <div class="call-center">
              <h6>ศูนย์บริการลูกค้า</h6>
              <a
                class="telephone"
                :href="'tel:' + salepage.sale_page.service_call"
              >{{ salepage.sale_page.service_call }}</a>
            </div>
            <div class="counsel-right">
              <button 
                class="btn btn--contact btn--square btncall popup-callback"
              >{{ salepage.sale_page.button_title }}</button>
              <button class="btn btn--square btn--share showAccount" @click="shareButton()">
                Share
                <i class="fas fa-share-alt"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <modelCallback v-show="btnmodelCallback_active" /> -->
    <modelCallback v-show="btnmodelCallback_active" />
    <modelShare v-show="btnmodelShare_active" />
  </header>
</template>

<script>
import axios from "axios";
import { mapGetters, mapState, mapActions } from "vuex";
import modelCallback from "@/components/modal/callback";
import modelShare from "@/components/modal/share";
export default {
  components: {
    modelCallback,
    modelShare
  },
  data() {
    return {
      btnmodelCallback_active: false,
      btnmodelShare_active: false
    };
  },
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    ...mapGetters(["currentUrl", "salepage", "codeaffiliate"])
  },
  methods: {
    ...mapActions({ CreatecodeAffiliate: "CreatecodeAffiliate" }),
    showCallback() {

    },
    shareButton() {
      showAccount = $("#modal-share")
        .mobiscroll()
        .popup({
          display: "center",
          cssClass: "mbsc-no-padding",
          buttons: [],
          layout: "liquid"
        })
        .mobiscroll("getInst");
      showAccount.show();
    }
  },
  async mounted() {
    let dataAff = { permalink: GLB_permalink };
    await this.CreatecodeAffiliate(JSON.stringify(dataAff));
    //if (this.codeaffiliate != '') {
    await axios
      .get(main_url_share + "/get_share_url/" + this.codeaffiliate.code)
      .then(res => {
        this.$store.state.urlshare = res.data;
        // this.urlshare.url_affiliate = res.data.url_affiliate;
        // this.urlshare.url_affiliate_status = res.data.url_affiliate_status;
        // this.urlshare.url_facebook = res.data.url_facebook;
        // this.urlshare.url_line = res.data.url_line;
      })
      // eslint-disable-next-line
      .catch(error => console.log(error));
    //}
  }
};
</script>

<style>
</style>